import { useMemo } from 'react';

import { useTracking as useTrackingBase } from '@change-corgi/core-react/tracking';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';
import { useTrackOnce } from 'src/app/shared/hooks/tracking';

type TrackingFunctions = {
	trackClick: () => void;
	trackView: () => void;
};

export function useTracking(): TrackingFunctions {
	const track = useTrackingBase();
	const trackOnce = useTrackOnce();

	const {
		data: {
			petition: { id: petitionId },
		},
	} = usePetitionDetailsPageData();

	return useMemo(
		() => ({
			trackClick: () => {
				void track('scroll_to_sign_click', {
					context: 'petitions_show',
					petition_id: petitionId,
				});
			},
			trackView: () => {
				void trackOnce('scroll_sign_form_view', {
					context: 'petitions_show',
					petition_id: petitionId,
				});
			},
		}),
		[track, trackOnce, petitionId],
	);
}
